<script>
  import { changeMessage, separateNumberIntoUnits } from "../js/functions.js"

  import { _ } from "svelte-i18n"

  import { onMount } from "svelte"

  import { helpFlag, state, praxi, taxi, planetIndex } from "../js/stores.js"

  import {
    animateBg,
    animateBg2,
    animateBg3,
    animateIcon,
  } from "../js/animations.js"

  import { slide } from "svelte/transition"
  import gsap from "gsap/gsap-core"

  let num1Dekades,
    num1Monades,
    num1 = {},
    num2 = {},
    kratoumeno = false,
    composite = {}

  let helpTimeline = gsap.timeline()
  let astronautisTimeline = gsap.timeline({
    onReverseComplete: () => {
      helpTimeline.kill()
    },
  })

  const numTable = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

  $: if ($state.solution1 > 0) num1 = separateDigits($state.solution1)
  $: if ($state.solution2 > 0) num2 = separateDigits($state.solution2)
  $: kratoumeno = num1.monades + num2.monades >= 10 ? true : false
  $: if (kratoumeno) composite = separateDigits(num1.monades + num2.monades)
  $: console.log(composite)

  function separateDigits(num) {
    let numObj = { dekades: 0, monades: 0 }
    let arr = separateNumberIntoUnits(num)
    if (arr.length === 2) {
      numObj.dekades = arr[0] / 10
      numObj.monades = arr[1]
    } else {
      numObj.monades = arr[0]
    }

    return numObj
  }

  function animateKratoumeno() {
    if (kratoumeno) {
      const kratoumeno = document.getElementById("kratoumeno")
      const target = document.getElementById("kratoumeno-dekades")

      gsap.set(kratoumeno, { left: 0, top: 0, x: 0, y: 0 })

      let cords1 = kratoumeno.getBoundingClientRect()
      let cords2 = target.getBoundingClientRect()

      console.log(cords1)
      let offsetY = cords2.y - cords1.y + cords1.height / 2

      return gsap
        .timeline()
        .add(animateBg2(kratoumeno, false, 1), "together")
        .to(kratoumeno, { borderRadius: 10, duration: 1 }, "together")
        .to(
          kratoumeno,
          {
            y: offsetY,
            duration: 2,
          }
          // "together"
        )
    } else {
      return gsap.timeline()
    }
  }

  function splitKratoumeno() {
    const monadesResult = document.getElementById("monades-result")
    const kratoumenoElement = document.getElementById("kratoumeno")

    if (kratoumeno) {
      return gsap
        .timeline()
        .add(animateBg(kratoumenoElement), "together")
        .add(animateIcon(kratoumenoElement, true), "together")
        .add(animateBg(monadesResult), "together")
        .add(animateIcon(monadesResult, true), "together")
        .add(animateKratoumeno(), "+=0.8")
    } else {
      return gsap
        .timeline()
        .add(animateBg(monadesResult), "together")
        .add(animateIcon(monadesResult, true), "together")
    }
  }

  function animateMonades() {
    const monades1 = document.getElementById("monades1")
    const monades2 = document.getElementById("monades2")

    const monadesPlus = document.getElementById("monades-plus")
    const monadesTo = document.getElementById("monades-to")

    // const finalKratoumenoContainer = document.getElementById(
    //   "kratoumeno-dekades"
    // )

    return (
      gsap
        .timeline({
          onStart: () => {
            changeMessage($_("monadesFirst"))
          },
          onComplete: () => {
            changeMessage($_("dekadesNext"))
          },
        })
        // .add(animateAstronautis())
        .add(animateBg(monades1), "+=2")
        .add(animateIcon(monadesPlus, true))
        .add(animateBg(monades2))
        .add(animateIcon(monadesTo, true))
        .add(splitKratoumeno())
    )
  }

  function animateKratoumenoIcon() {
    if (kratoumeno) {
      const kratoumenoPlusIcon = document.getElementById(
        "kratoumeno-dekades-plus"
      )
      return animateIcon(kratoumenoPlusIcon, true)
    } else {
      return gsap.timeline()
    }
  }

  function animateDekades() {
    const dekades1 = document.getElementById("dekades1")
    const dekades2 = document.getElementById("dekades2")
    const dekadesResult = document.getElementById("dekades-result")

    gsap.set(dekadesResult, { display: "block" })

    const dekadesPlus = document.getElementById("dekades-plus")
    const dekadesTo = document.getElementById("dekades-to")

    return gsap
      .timeline()
      .add(animateKratoumenoIcon(), "+=2")
      .add(animateBg2(dekades1))
      .add(animateIcon(dekadesPlus, true))
      .add(animateBg2(dekades2))
      .add(animateIcon(dekadesTo, true))
      .add(animateBg2(dekadesResult), "together")
      .add(animateIcon(dekadesResult, true), "together")
  }

  function animateSolutionProsthesi() {
    const dekadesResult = document.getElementById("dekades-result")
    const monadesResult = document.getElementById("monades-result")

    helpTimeline = gsap
      .timeline({
        onReverseComplete: function () {
          this.timeScale(1).play()
        },
      })
      .add(animateMonades())
      .add(animateDekades())
      .add(animateBg3(dekadesResult), "+=2")
      .add(animateBg3(monadesResult), "<")
  }

  function animateSolutionpropaideia() {
    helpTimeline = gsap
      .timeline({
        onReverseComplete: function () {
          this.timeScale(1).play()
        },
      })
      .fromTo(
        ".staggered",
        { opacity: 0 },
        { opacity: 1, duration: 1, stagger: 0.2 }
      )
      .add(animateCorrectpropaideia())
  }

  function animateCorrectpropaideia() {
    // let answer1 = document.getElementsByClassName("answer1")
    // let answer2 = document.getElementsByClassName("answer2")
    // let result = document.getElementsByClassName("result")[0]
    // console.log(result)
    return gsap
      .timeline()
      .add(animateBg(".answer1"))
      .add(animateBg(".answer2"))
      .add(animateBg(".result"))
  }

  function playAgain() {
    helpTimeline.timeScale(10).reverse()
    // check onReverseComplete on helpTimeline
  }

  function animateAstronautis() {
    let targetPosition = document.getElementById("astro-position")
    let astronautis = document.getElementById("astronautis-whole")
    // console.log(astronautis)

    let cords1 = targetPosition.getBoundingClientRect()
    let cords2 = astronautis.getBoundingClientRect()
    console.log(cords1, cords2)

    let offsetX = cords2.right - cords1.right
    let offsetY = cords2.top - cords1.top

    astronautisTimeline.to(astronautis, {
      x: -offsetX,
      y: -offsetY,
      duration: 1,
    })

    return astronautisTimeline
  }

  function closeModal() {
    // astronautisTimeline.reverse()
    helpTimeline.kill()
    $helpFlag = false
    changeMessage("")
  }

  onMount(() => {
    // let result = document.getElementsByClassName("result")
    // console.log(result[0])
    // alert("ok")

    // console.log("asked for help")

    plausible("Help", {
      props: {
        planet: $planetIndex,
        praxi: $praxi,
        taxi: $taxi,
      },
    })

    $praxi === "prosthesi"
      ? animateSolutionProsthesi()
      : animateSolutionpropaideia()
  })
</script>

<div class="help-container" transition:slide>
  <div class="help-actions">
    <button class="close-btn" on:click={closeModal}>
      <svg viewBox="0 0 20 20" fill="currentColor" class="check-circle">
        <path
          fill-rule="evenodd"
          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0
          00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0
          001.414 0l4-4z"
          clip-rule="evenodd"
        />
      </svg>
      {$_("gotIt")}
    </button>
    <button class="play-again" on:click={playAgain}>
      <svg viewBox="0 0 20 20" fill="currentColor" class="play">
        <path
          fill-rule="evenodd"
          d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0
          001.555.832l3-2a1 1 0 000-1.664l-3-2z"
          clip-rule="evenodd"
        />
      </svg>
      {$_("againPlease")}
    </button>
  </div>

  <div class="numbers-grid">
    {#if $praxi === "prosthesi"}
      <div class="grid-container">
        <!-- <div class="grid-item test1 dekades">5</div>
        <div class="grid-item test2 monades">7</div> -->

        {#if kratoumeno}
          <div
            class="grid-item dekades"
            id="kratoumeno-dekades"
            style="visibility: hidden"
          >
            5
          </div>
          <div class="grid-item monades" />
          <div class="grid-praxi" id="kratoumeno-dekades-plus">
            <svg viewBox="0 0 20 20" fill="currentColor" class="plus-circle">
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100
            2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
          <div class="grid-praxi" />
        {/if}

        <div id="dekades1" class="grid-item grid-item-1 dekades">
          {num1.dekades}
        </div>
        <div id="monades1" class="grid-item grid-item-2 monades">
          {num1.monades}
          <div id="astro-position" />
        </div>
        <div class="grid-praxi" id="dekades-plus">
          <svg viewBox="0 0 20 20" fill="currentColor" class="plus-circle">
            <path
              fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100
            2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z"
              clip-rule="evenodd"
            />
          </svg>
        </div>
        <div class="grid-praxi" id="monades-plus">
          <svg viewBox="0 0 20 20" fill="currentColor" class="plus-circle">
            <path
              fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100
            2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z"
              clip-rule="evenodd"
            />
          </svg>
        </div>
        <div id="dekades2" class="grid-item grid-item-3 dekades">
          {num2.dekades}
        </div>
        <div id="monades2" class="grid-item grid-item-4 monades">
          {num2.monades}
        </div>
        <div class="grid-praxi" id="dekades-to">
          <svg
            viewBox="0 0 20 20"
            fill="currentColor"
            class="arrow-circle-down"
          >
            <path
              fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v3.586L7.707
            9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0
            00-1.414-1.414L11 10.586V7z"
              clip-rule="evenodd"
            />
          </svg>
        </div>
        <div class="grid-praxi" id="monades-to">
          <svg
            viewBox="0 0 20 20"
            fill="currentColor"
            class="arrow-circle-down"
          >
            <path
              fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v3.586L7.707
            9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0
            00-1.414-1.414L11 10.586V7z"
              clip-rule="evenodd"
            />
          </svg>
        </div>
        <div class="grid-item-5" style="position: relative">
          {#if kratoumeno}
            <div
              id="kratoumeno"
              class="dekades grid-item"
              style="position: absolute;"
            >
              {composite.dekades}
            </div>
          {/if}

          <div
            style="display: none"
            id="dekades-result"
            class="dekades grid-item"
          >
            {#if kratoumeno}
              {num1.dekades + num2.dekades + composite.dekades}
            {:else}
              {num1.dekades + num2.dekades}
            {/if}
          </div>
        </div>
        <div class="grid-item grid-item-6 monades" id="monades-result">
          {#if kratoumeno}
            {composite.monades}
          {:else}
            {num1.monades + num2.monades}
          {/if}
        </div>

        <!-- <div class="grid-item">
          <div class="pill">Δεκάδες</div>
        </div>
        <div class="grid-item">
          <div class="pill">Μονάδες</div>
        </div> -->
      </div>
    {:else}
      <div class="propaideia">
        <h1>
          {$_("timesTable", {
            values: { num: $state.solution1 },
          })}
        </h1>
        {#each numTable as num}
          <div class="staggered">
            <div class:answer1={num * $state.solution1 === $state.targetNum}>
              {$state.solution1}
            </div>
            <div>x</div>
            <div class:answer2={num * $state.solution1 === $state.targetNum}>
              {num}
            </div>
            <div>=</div>
            <div class:result={num * $state.solution1 === $state.targetNum}>
              {$state.solution1 * num}
            </div>
          </div>
        {/each}
      </div>
    {/if}
  </div>
</div>

<style>
  .test1 {
    background: #c9440b !important;
  }
  .test2 {
    background: #ff7941 !important;
  }

  .propaideia {
    color: #fff;
  }

  .propaideia h1 {
    margin: 10px 0;
  }

  .propaideia div {
    padding: 0 6px;
    border-radius: 6px;
  }

  .staggered {
    display: flex;
    /* gap: 10px; */
    font-size: 2rem;
    /* justify-content: space-between; */
  }

  .help-container {
    background: rgba(0, 0, 0, 0.9);
    border-radius: 20px;
    z-index: 80;
    width: 80vw;
    height: 90vh;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
  }

  .help-actions {
    position: absolute;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 10px;
    padding-top: 20px;
    padding-right: 20px;
  }

  .numbers-grid {
    display: flex;
    /* flex-direction: column; */
    align-items: center;
    justify-content: center;
    height: 100%;
    /* height1 */
  }

  .close-btn,
  .play-again {
    /* margin-top: 40px; */
    /* position: absolute; */
    width: 270px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    padding: 10px 16px;
    font-size: 20px;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.2);
    color: white;
    border: 1px solid rgba(255, 255, 255, 0.6);
    gap: 6px;
  }

  svg {
    margin-top: -3px;
  }

  /* .close-btn {
    top: 20px;
    right: 20px;
  }

  .play-again {
    top: 80px;
    right: 20px;
  } */

  .close-btn:hover,
  .play-again:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  .check-circle,
  .play {
    color: #96dd77;
    width: 30px;
  }

  .play {
    color: #ff7941;
  }

  .grid-container {
    /* margin-left: 50px; */
    /* min-width: 20px; */
    display: grid;
    grid-template-columns: 1fr 1fr;
    /* grid-template-rows: 5fr 1fr; */
    grid-row-gap: 10px;
    align-items: center;
    justify-items: center;
  }

  .grid-item {
    font-size: 70px;
    color: white;
    /* background: #ff621f; */
    background-color: none;
    padding: 10px 5px;
    border-radius: 10px;
  }

  .dekades {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .monades {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  #monades1 {
    position: relative;
  }
  #astro-position {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 100px;
    right: -100px;
    /* background: greenyellow; */
  }

  .plus-circle,
  .arrow-circle-down {
    opacity: 1;
    width: 40px;
    color: #96dd77;
  }

  @media (max-width: 600px) {
    #astro-position {
      top: 400px;
    }

    .help-actions {
      /* align-items: center; */
      /* justify-content: center; */
      position: relative;
      /* right: 0; */
      align-items: center;
      padding-right: 0px;
    }

    .grid-item {
      font-size: 45px;
      /* width: 100%; */
    }

    .plus-circle,
    .arrow-circle-down {
      opacity: 1;
      width: 30px;
      color: #96dd77;
    }

    .close-btn,
    .play-again {
      width: 200px;
      padding: 5px 7px;
      font-size: 14px;
    }

    .check-circle,
    .play {
      width: 20px;
    }

    .propaideia h1 {
      font-size: 1.5rem;
    }

    .propaideia div {
      font-size: 1.5rem;
    }
  }

  @media (max-height: 700px) {
    .grid-item {
      font-size: 30px;
    }

    .plus-circle,
    .arrow-circle-down {
      width: 25px;
    }
  }
</style>
